const sectionValidations = {
  title: {
    required: true,
    minLength: 2,
  },
};

const lessonValidations = {
  title: {
    required: true,
    minLength: 2,
  },
  file: {
    required: true,
  },
  questions: {
    atLeastOne: true,
    array: {
      content: { required: true },
      answers: {
        atLeastOne: true,
        array: {
          content: { required: true },
        },
      },
    },
  },
};

export { sectionValidations, lessonValidations };
